export default {
  landingPage: 'landingPage',
  connectionType: 'connectionType',
  createWallet: 'createWallet',
  accessWallet: 'accessWallet',
  exitDashboard: 'exitDashboard',
  networkSwitch: 'networkSwitch',
  gasSwitch: 'gasSwitch',
  swap: 'swap',
  dapp: 'dapp',
  swapRates: 'swapRates',
  globalError: 'globalError'
};
